import getCurrentPeriod from "./get-current-period";

export default function matchCurrentVolume({ state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // Once the container is loaded, return the current volume.
  // If the current date does not fall into any of the
  // defined dates, return null.
  // Next or previous dates are auto-determined in `autoVolume`.
  return getCurrentPeriod(state.container.volumes);
}
